import { Component, OnInit, ViewChild } from '@angular/core';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { CardTableRowComponent } from 'libs/portal/src/modules/tools/card-table/components';
import { CardTableHeader } from 'libs/portal/src/modules/tools/card-table/models/card-table-header.model';
import { MatDateRangePicker } from '@angular/material/datepicker';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { DateTimeComponent } from 'libs/portal/src/modules/tools/date-time/date-time.component';
import { Subscription, forkJoin } from 'rxjs';
import { CardTableOptions } from 'libs/portal/src/modules/tools/card-table/models';
import { ScreenSize } from 'libs/portal/src/layout/layout.service';
import { PaginationService } from 'libs/portal/src/services/pagination/pagination.service';
import { GenericTableHeaderOptions } from 'libs/portal/src/modules/tools/card-table/models/generic-table-header-options.model';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { ServerGroups } from '../../relay/interfaces/DashboardServer.interface';

@Component({
  selector: 'app-relay-apn-report',
  templateUrl: './relay-apn-report.component.html',
  styleUrls: ['./relay-apn-report.component.scss'],
})
export class RelayApnReportComponent implements OnInit {
  @ViewChild('dates', { static: false }) datesComponent: DateTimeComponent;
  @ViewChild('table', { static: false }) public table: CardTableRowComponent;
  @ViewChild('resultsTable', { static: false }) public resultsTable: CardTableRowComponent;

  loading = false;
  todayT = new Date();
  endBeforeStart = false;
  resetHeader = false;
  currentPage = 0;
  groups: any[] = [];
  apns: any[] = [];
  group = '';
  startDate: string;
  endDate: string;
  resetting = false;
  reportResults: any[] = [];
  selectionMap = {};
  resultsCurrentPage = 0;
  showAPNTable = false;
  ScreenSize = ScreenSize;

  authSubscription: Subscription;
  obfuscateDetails = false;
  displayResults = false;

  headerOptions: GenericTableHeaderOptions = {
    ShowSearch: false,
    DefaultDesc: true,
    DateItem: {
      Singular: false,
      Title: 'Select date range',
      StartDate: this.tools.StartOfMonth().toDateString(),
      EndDate: new Date().toDateString(),
    },
    DateRequired: true,
    EnableExport: false,
    EnableSelectAll: false,
    DropDownOptions: [],
  };

  options: CardTableOptions = {
    titleProperty: 'Name',
    rowId: 'ID',
    subTitleProperty: 'data',
    additionalProperty: 'status',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['selected', 'ID', 'Description', 'OriginalName'],
    stylePropertyPrefix: 'alerts',
    clickableFlexCard: false,
    textSize: 'regular',
  };

  resultOptions: CardTableOptions = {
    rowId: 'ID',
    subTitleProperty: 'data',
    additionalProperty: 'status',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['ID', 'Description'],
    stylePropertyPrefix: 'alerts',
    clickableFlexCard: false,
    textSize: 'regular',
  };

  resultsHeaders: CardTableHeader[] = [
    {
      ID: 'Date',
      Index: 0,
      Sort: 'Date',
      Sortable: false,
      Width: 10,
      Text: 'Date',
    },
    {
      ID: 'APN',
      Index: 0,
      Sort: 'APN',
      Sortable: false,
      Width: 10,
      Text: 'APN',
    },
    {
      ID: 'Group',
      Index: 1,
      Sort: 'Group',
      Sortable: false,
      Width: 10,
      Text: 'Group',
    },
    {
      ID: 'Server',
      Index: 2,
      Sort: 'Server',
      Sortable: false,
      Width: 10,
      Text: 'Server',
    },
    {
      ID: 'ServerLink',
      Index: 3,
      Sort: 'ServerLink',
      Sortable: false,
      Width: 10,
      Text: 'Server Link',
    },

    {
      ID: 'TotalSuccess',
      Index: 4,
      Sort: 'TotalSuccess',
      Sortable: false,
      Width: 10,
      Text: 'Success Total',
      Wrapper: (obj, elem) => {
        if (elem != null) {
          return Math.round(elem);
        }
        return '-';
      },
    },
    {
      ID: 'TotalFailed',
      Index: 4,
      Width: 10,
      Sort: 'TotalFailed',
      Sortable: false,
      Text: 'Failed Total',
      Wrapper: (obj, elem) => {
        if (elem != null) {
          return Math.round(elem);
        }
        return '-';
      },
    },
    {
      ID: 'TotalNull',
      Index: 4,
      Width: 10,
      Sort: 'TotalNull',
      Sortable: false,
      Text: 'Null Total',
      Wrapper: (obj, elem) => {
        if (elem != null) {
          return Math.round(elem);
        }
        return '-';
      },
    },
    {
      ID: 'TotalTx',
      Index: 4,
      Width: 10,
      Sort: 'TotalTx',
      Sortable: false,
      Text: 'Total Tx',
      Wrapper: (obj, elem) => {
        if (elem != null) {
          return Math.round(elem);
        }
        return '-';
      },
    },
    {
      ID: 'TotalRx',
      Index: 4,
      Width: 10,
      Sort: 'TotalRx',
      Sortable: false,
      Text: 'Total Rx',
      Wrapper: (obj, elem) => {
        if (elem != null) {
          return Math.round(elem);
        }
        return '-';
      },
    },
  ];

  headers: CardTableHeader[] = [
    {
      ID: 'Name',
      Index: 0,
      Sort: 'Name',
      Sortable: true,
      Text: 'APN Name',
    },
  ];

  constructor(
    private genericService: GenericService,
    private endpoints: Endpoints,
    private tools: ToolsService,
    private paginationService: PaginationService,
    private auth: UserRightsService,
  ) {}

  ngOnInit() {
    this.authSubscription = this.auth.GetUser().subscribe((user) => {
      const prev = this.obfuscateDetails;
      if (user.isObfuscated) {
        this.obfuscateDetails = true;
      } else {
        this.obfuscateDetails = false;
      }

      if (prev != this.obfuscateDetails) {
        this.reset();
      } else {
        this.getGroups();
      }
    });
  }

  getGroups() {
    this.groups = [];
    this.apns = [];
    this.group = '';
    this.headerOptions.DropDownOptions = [];
    this.resetting = true;
    this.startDate = this.tools.isoDateWithoutTimeZone(this.tools.GetStartOfMonth(new Date())).toISOString();
    this.endDate = this.tools.GetEndOfDay(this.tools.isoDateWithoutTimeZone(new Date())).toISOString();
    let ep1 = this.genericService.GET(this.endpoints.GET_RELAY_GROUPS);
    let ep2 = this.genericService.POST(this.endpoints.GET_RELAY_APNS, { ServerLinkIDs: [] });
    forkJoin([ep1, ep2]).subscribe(
      ([groups, apns]) => {
        let serverArray = groups['body'];
        if (serverArray) {
          serverArray.forEach((element: ServerGroups) => {
            element.OriginalName = element.GroupName;
            if (this.obfuscateDetails) {
              element.GroupName = this.tools.Obfuscate(element.GroupName, 'Group ', 4);
            }
            if (element.GroupName == '') {
              element.GroupName = 'Unassigned';
            }
            this.groups.push(element);
          });
          this.headerOptions.DropDownOptions[0] = {
            Label: 'Group',
            options: this.groups,
            attribute: 'GroupName',
          };
        }

        if (apns['body'] && apns) {
          apns['body'].forEach((element) => {
            this.apns.push({
              selected: false,
              Name: this.obfuscateDetails ? this.tools.Obfuscate(element.Name, 'APN ', 4) : element.Name,
              OriginalName: element.Name,
            });
            this.selectionMap[element.OriginalName] = false;
          });
        }
        this.resetting = false;
      },
      (error: any) => {
        console.log(error);
      },
    );
  }

  updateStart(event: string) {
    this.startDate = event;
  }

  updateEnd(event: string) {
    this.endDate = event;
  }

  reset() {
    this.resetting = true;
    this.apns = [];
    this.group = '';
    this.getGroups();
    this.resetHeader = true;
    this.showAPNTable = false;
    this.headerOptions.EnableClear = false;
    this.headerOptions.EnableView = false;
    this.headerOptions.EnableExport = false;
    this.headerOptions.EnableSelectAll = false;
    this.reportResults = [];
    this.apns.forEach((apn) => {
      apn.selected = false;
      this.selectionMap[apn.OriginalName] = false;
    });
    this.startDate = this.tools.GetStartOfMonth(this.todayT).toISOString();
    this.endDate = new Date().toISOString();

    setTimeout(() => {
      this.resetHeader = false;
      this.resetting = false;
    });
  }

  isValid(): Boolean {
    if (this.group != '' || (this.apns && this.apns.length > 0)) {
      return true;
    }
    return false;
  }

  createObject(): Object {
    let apnList = [];
    Object.entries(this.selectionMap).forEach(([key, element]) => {
      if (element == true) {
        apnList.push(key);
      }
    });

    return {
      StartDate: this.startDate,
      EndDate: this.endDate,
      APNs: apnList.length > 0 ? apnList : [],
      Group: this.group,
    };
  }

  EnquireReportInfo() {
    if (this.isValid()) {
      this.reportResults = [];
      this.loading = true;
      this.genericService.POST(this.endpoints.GENERATE_RELAY_APN_REPORT(true, false), this.createObject()).subscribe((results) => {
        let tempReportResults = results['body'] as [];
        this.showAPNTable = false;
        this.group = '';
        this.apns.forEach((apn) => {
          apn.selected = false;
          this.selectionMap[apn.OriginalName] = false;
        });

        if (tempReportResults && tempReportResults.length > 0) {
          tempReportResults.forEach((element: any) => {
            this.reportResults.push({
              Date: this.tools.FormatSwedishDateTime(this.tools.ParseAPIDate(element.Date)),
              APN: element.APN != null ? (this.obfuscateDetails && element.APN.length > 0 ? this.tools.Obfuscate(element.APN, 'APN ', 4) : element.APN) : '-',
              Group: element.Group != null ? (this.obfuscateDetails && element.Group.length > 0 ? this.tools.Obfuscate(element.Group, 'Group ', 4) : element.Group) : '-',
              Server: element.Server != null ? (this.obfuscateDetails && element.Server.length > 0 ? this.tools.Obfuscate(element.Server, 'Server ', 4) : element.Server) : '-',
              ServerLink:
                element.ServerLink != null
                  ? this.obfuscateDetails && element.ServerLink.length > 0
                    ? this.tools.Obfuscate(element.ServerLink, 'Link ', 4)
                    : element.ServerLink
                  : '-',
              TotalSuccess: element.TotalSuccess ?? 0,
              TotalFail: element.TotalFail ?? 0,
              TotalNull: element.TotalNull ?? 0,
              TotalTx: element.TotalTx ?? 0,
              TotalRx: element.TotalRx ?? 0,
            });
          });
        }

        this.displayResults = true;
        this.loading = false;
      });
    }
  }

  downloadReport() {
    if (this.isValid()) {
      this.loading = true;
      this.genericService.download(this.endpoints.GENERATE_RELAY_APN_REPORT(null, false), this.createObject()).subscribe((_results) => {
        this.loading = false;
        this.reset();
      });
    }
  }

  groupSelect(event: any) {
    this.showAPNTable = true;
    this.headerOptions.EnableView = false;
    this.headerOptions.EnableClear = false;
    this.headerOptions.EnableSelectAll = true;
    this.headerOptions.EnableExport = false;
    this.group = event.Value.OriginalName;
  }

  onPageChange(event: any) {
    this.currentPage = event;
    const startIndex = (this.currentPage - 1) * 10;
    let endIndex = startIndex + 10;
    if (endIndex > this.apns.length) {
      endIndex = this.apns.length;
    }
    setTimeout(() => {
      this.paginationService.emit();
    });
  }

  onPageChangeResult(event: any) {
    this.resultsCurrentPage = event;
    const startIndex = (this.resultsCurrentPage - 1) * 10;
    let endIndex = startIndex + 10;
    if (endIndex > this.apns.length) {
      endIndex = this.apns.length;
    }
    setTimeout(() => {
      this.paginationService.emit();
    });
  }

  selectionMade(event: any) {
    this.headerOptions.EnableView = false;
    this.headerOptions.EnableClear = false;
    this.headerOptions.EnableExport = false;
    this.selectionMap[event.OriginalName] = !this.selectionMap[event.OriginalName];
    Object.entries(this.selectionMap).forEach(([key, element]) => {
      if (element == true) {
        this.headerOptions.EnableView = true;
        this.headerOptions.EnableClear = true;
        this.headerOptions.EnableExport = true;
      }
    });
  }

  selectAll(event) {
    if (event == true) {
      this.headerOptions.EnableView = true;
      this.headerOptions.EnableClear = true;
      this.headerOptions.EnableExport = true;
    } else {
      this.headerOptions.EnableView = false;
      this.headerOptions.EnableClear = false;
      this.headerOptions.EnableExport = false;
    }
    this.apns.forEach((apn) => {
      apn.selected = event;
      this.selectionMap[apn.OriginalName] = event;
    });
  }

  setDate(event: any) {
    if (event.endDate != null) {
      this.startDate = this.tools.isoDateWithoutTimeZone(new Date(event.startDate)).toISOString();
      this.endDate = this.tools.GetEndOfDay(this.tools.isoDateWithoutTimeZone(new Date(event.endDate))).toISOString();
    }
  }
}
